/// <amd-module name="Analytics/Shared/TrendChart/TrendChartView/ControllerViews/TrendChartView" />
import { ITrendChartState, ITrendChartStore } from "Analytics/Shared/TrendChart/Common/Types";
import { ColumnChartVisual, IColumnChartVisualProps } from "Analytics/Shared/Visuals/ColumnChartVisual/Components/ColumnChartVisual";
import { AnalyticsUnavailableMessage } from "Analytics/Shared/Visuals/Common/Components/AnalyticsUnavailableMessage";
import * as React from "react";
import { Components, css, IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

export interface ITrendChartProps extends IVssComponentProperties {
    store: ITrendChartStore;
    title?: string;
    titleClassName?: string;
    chartContainerClassName?: string;
    onMetricChanged?: (metricOptionSelected: number) => void;
    onDataRendered?: () => void;
    useBoltCard?: boolean;
}

export class TrendChartView extends VssComponent<ITrendChartProps, ITrendChartState> {
    private _onDataRenderedCalled = false;
    constructor(props: ITrendChartProps, context: IVssComponentContext) {
        super(props, context);
        this.state = this.props.store.getState() || {};
    }

    public async componentDidMount() {
        if (this.props) {
            this.props.store.addChangedListener(this._onStoreUpdate);
            this.setState(this.props.store.getState() || {});
        }
    }

    public render(): JSX.Element {
        return (
            <ColumnChartVisual
                className={this.props.className}
                title={this.props.title}
                titleClassName={this.props.titleClassName}
                chartContainerClassName={this.props.chartContainerClassName}
                {...this._getColumnChartVisualProperties()}
                useBoltCard={this.props.useBoltCard}
            />
        );
    }

    public componentDidUpdate(prevProps: ITrendChartProps, prevState: ITrendChartState): void {
        if (this.state.errorText || (this.state.chartOptions && Object.keys(this.state.chartOptions).length > 0)) {
            this.props.onDataRendered && !this._onDataRenderedCalled && this.props.onDataRendered();
            this._onDataRenderedCalled = true;
        }

        super.componentDidUpdate(prevProps, prevState);
    }

    private _getColumnChartVisualProperties(): IColumnChartVisualProps | null {
        const errorTextRenderer = (errorText?: string) => <AnalyticsUnavailableMessage suggestion={errorText} />;
        if (this.state.errorText) {
            return {
                errorText: this.state.errorText,
                errorTextRenderer: errorTextRenderer,
                className: css("tests-column-chart-view-section", this.props.className || "")
            };
        }

        if (!this.state.chartOptions || Object.keys(this.state.chartOptions).length === 0) {
            return null;
        }

        this.state.chartOptions.pageContext = this.context.pageContext;
        // Todo Check where to add the aria-label
        return {
            chartOptions: this.state.chartOptions,
            columnChartLabelledMenuProps: !this.props.title
                ? {
                      metricOptions: this.state.metricsOptions,
                      selectedMetricOption: this.state.metricSelected,
                      onMetricChange: this._onMetricChanged
                  }
                : null,
            className: css("tests-column-chart-view-section", this.props.className || "")
        } as IColumnChartVisualProps;
    }

    private _onMetricChanged = (metricOptionSelected: number) => {
        if (this.props.onMetricChanged) {
            this.props.onMetricChanged(metricOptionSelected);
        }
    };

    private _onStoreUpdate = () => {
        this.setState(this.props.store.getState());
    };
}

Components.add("TrendChartView", TrendChartView);
